import styled from 'styled-components';

import { SWReactIcons } from '@similarweb/icons';
import { colorsPalettes, setFontVariant } from '@similarweb/styles';

import { Button } from '../Button';

export const HEADER_HEIGHT = 56;

export const StyledHeader = styled.header`
  padding: 0 12px 0 16px;
  display: flex;
  align-items: center;
  align-content: center;
  height: ${HEADER_HEIGHT}px;
  border-bottom: 1px solid #f0f0f0;
`;

export const StyledLogo = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-right: auto;

  svg {
    margin-top: 1px;
  }
`;

export const StyledLogoText = styled.div`
  display: flex;
  flex-direction: column;
  ${setFontVariant('button', colorsPalettes.carbon[500])};
  line-height: 100%;
  font-size: 12px;

  span:last-child {
    font-weight: 300;
    font-size: 9px;
  }
`;

export const StyledSettingsButton = styled(Button)`
  padding: 4px;

  &:disabled {
    cursor: unset;
  }

  ${SWReactIcons} svg path {
    fill: ${colorsPalettes.carbon[300]};
  }
`;
